/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import useApi from '../../../../hooks/useQuery'
import {GET_BUSINESS_STEPS, GET_VISTING_HOURS} from '../GraphQLQueries/Dashboard'
import {LoadingSpinner} from '../../../../_ePulse/layout/components/LoadingSpinner'
import moment from 'moment'
import useLocalStorageFetch from '../../../../hooks/localStorageFetch'
import {toAbsoluteUrl} from '../../../../_ePulse/helpers'
import {Link} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {checkPermission} from '../../../App'
type Props = {
  className: string
}

const VisitingHours: React.FC<Props> = ({className}) => {
  const [visitingHours, setVisitingHours] = useState<any>([])
  const [businessSteps, setbusinessSteps] = useState<any>([])
  const {role} = useLocalStorageFetch()
  const reduxData: any = useSelector((state) => {
    return state
  })

  const {data, loading, error, refetch} = useApi(true, GET_VISTING_HOURS, {})
  // const {
  //   data: businessStepData,
  //   loading: businessSteploading,
  //   error: businessStepError,
  //   refetch: businessStepRefetch,
  // } = useApi(true, GET_BUSINESS_STEPS, {})

  useEffect(() => {
    // refetch()
    // businessStepRefetch()
    if (data) {
      const res = data?.getDoctorVisitingHours.weeklySlotsDetails

      setVisitingHours(res)
    }
    // if (businessStepData) {
    //   const res = data?.getDoctorVisitingHours.weeklySlotsDetails
    //   setbusinessSteps(res)
    // }
  }, [data])

  function formatTimings(timings: any) {
    if (!timings?.length) return 'NA' // Handle empty array

    let formattedSlots = timings?.map(
      ({slotStart, slotEnd}: any) =>
        `${moment(slotStart).utc().format('HH:mm')}-${moment(slotEnd).utc().format('HH:mm')}`
    )

    return timings?.length > 2 ? `${formattedSlots[0]}, ...` : formattedSlots?.join(', ')
  }

  function formatTimingsforTooltip(timings: any) {
    if (!timings?.length) return 'NA' // Handle empty array

    let formattedSlots = timings?.map(
      ({slotStart, slotEnd}: any) =>
        `${moment(slotStart).utc().format('HH:mm')}-${moment(slotEnd).utc().format('HH:mm')}`
    )

    return formattedSlots?.join(', ')
  }

  return (
    <div className={`card ${className}`}>
      <LoadingSpinner isLoading={loading} />
      {/* begin::Header */}
      {/* <div className='px-8 border-0 mt-4'>
        <div className='d-flex flex-direcion-row justify-content-between col-12 align-items-center my-2'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>
              Visiting Hours & Business Steps Details
            </span>
          </h3>
        </div>
        <div className='separator mx-2' />
      </div> */}

      <div className='d-flex flex-column px-4'>
        {!reduxData.auth.isLinkedDoctor && checkPermission('getBusinessStaffList') && (
          <div className='col bg-white '>
            <Link
              to={`/${role}/staff-management`}
              className='d-flex align-items-sm-center mb-2 bg-light'
            >
              <div className='symbol symbol-50px me-5'>
                <span className='symbol-label'>
                  <img
                    src={toAbsoluteUrl('/media/ePulse/users.svg')}
                    className='h-50 align-self-center'
                    alt=''
                  />
                </span>
              </div>

              <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
                <div className='flex-grow-1 me-2'>
                  <a href='#' className='text-gray-800  fs-6 fw-bold'>
                    View Staff Members
                  </a>
                </div>

                <span className='badge badge-light fw-bold my-2'>
                  <img
                    src={toAbsoluteUrl('/media/ePulse/rightArrow.png')}
                    className='h-50 align-self-center'
                    alt=''
                  />
                </span>
              </div>
            </Link>
          </div>
        )}
        {visitingHours.length ? (
          <>
            <div className='px-3'>
              <span className='fs-3 fw-bold'>Visiting Hours</span>
              <div className='d-flex flex-row  align-items-center '>
                {/* <div className=' col px-2 fw-bold '>Sr. No.</div> */}
                <div className=' col px-2 py-1 fw-bold '>Day of week</div>
                {/* <div className=' col px-2 py-1 fw-bold '>Timings</div> */}
                <div className=' col px-2 py-1 fw-bold '>Open/Closed</div>
                {/* <div className=' col px-2 py-1 fw-bold '>24/7 Open</div> */}
                <div className=' col px-2 py-1 fw-bold '>Visting Hours</div>
              </div>
              {visitingHours?.map((input: any, index: any) => {
                return (
                  <div key={index} className='d-flex flex-row align-items-center'>
                    {/* <div className=' col px-2 py-1 '>{index + 1}</div> */}

                    <div className=' col px-2 py-1 '>{input?.dayOfWeek}</div>
                    {/* <div className=' col px-2 py-1 '>{input?.timings || 'NA'}</div> */}
                    <div className=' col px-2 py-1 '>
                      {/* {input?.isClosed ? 'Open' : input?.isClosed === false ? 'Close' : 'NA'} */}
                      {input?.isClosed === false ? 'Open' : 'Close'}
                    </div>
                    <div className=' col px-2 py-1 d-flex flex-row'>
                      {input?.isOpen24Hours ? (
                        <>
                          <span>24 hours</span>
                        </>
                      ) : (
                        <>
                          <span>{formatTimings(input?.timings)} </span>
                          <span>
                            <i
                              className='fas fa-exclamation-circle ms-2 fs-7'
                              data-bs-toggle='tooltip'
                              title={formatTimingsforTooltip(input?.timings)}
                            ></i>
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
            <div className='separator mx-2' />
          </>
        ) : (
          <div className='px-3'>
            <span className='fs-3 fw-bold'>Visiting Hours</span>
            <div className='d-flex flex-row  align-items-center mt-4'>
              <span className='fs-5 fw-normal'>Visiting hours are not added!!!</span>
            </div>
          </div>
        )}

        {/* {businessSteps.length ? (
          <>
            <div className='px-3'>
              <span className='fs-3 fw-bold'>Business Steps</span>
              <div className='d-flex flex-row  align-items-center my-3'>
                <div className=' col px-2 fw-bold '>Sr. No.</div>
                <div className=' col px-2 fw-bold '>Step Name</div>
                <div className=' col px-2 fw-bold '>Step Number</div>
                <div className=' col px-2 fw-bold '>Screen Name</div>
                <div className=' col px-2 fw-bold '>Completed</div>
                <div className=' col px-2 fw-bold '>Verified</div>
                <div className=' col px-2 fw-bold '>Optional</div>
              </div>
              {visitingHours?.map((input: any, index: any) => (
                <div key={index} className='d-flex flex-row align-items-center'>
                  <div className=' col px-2 '>{index + 1}</div>
                  <div className=' col px-2 '>{input.stepName}</div>
                  <div className=' col px-2 '>{input?.stepNumber}</div>
                  <div className=' col px-2 '>{input?.screenName}</div>
                  <div className=' col px-2 '>{input.isCompleted ? 'Yes' : 'No'}</div>
                  <div className=' col px-2 '>{input.isVerified ? 'Yes' : 'No'}</div>
                  <div className=' col px-2 '>{input.isOptional ? 'Yes' : 'No'}</div>
                </div>
              ))}
            </div>
            <div className='separator mx-2' />
          </>
        ) : (
          <></>
        )} */}
      </div>
    </div>
  )
}

export {VisitingHours}
